'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _jobRequests = require('./job-requests.component');

var _jobRequests2 = _interopRequireDefault(_jobRequests);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobRequestsModule = _angular2.default.module('app.containers.job-requests', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('jobRequests', {
    url: '/job-requests',
    template: '<job-requests></job-requests>'
  });
}).component('jobRequests', _jobRequests2.default);

exports.default = jobRequestsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-requests/job-requests.js
 **/